export default [
  {
    label: 'Individual',
    value: 'individual',
  },
  {
    label: 'TA',
    value: 'cpa',
  },
  // {
  //  label: "Group",
  //  value: "group",
  // },
];
